export const FOCUSABLE_NODE_NAMES = ['AREA', 'BUTTON', 'IFRAME', 'INPUT', 'OPTGROUP', 'OPTION', 'SELECT', 'TEXTAREA'];
